export default __webpack_public_path__ + "static/media/freewheel_ids.d9a685bb.csv";